/**
 * 이벤트 큐 관리
 *
 * 이벤트를 메모리 큐에 저장하고, 배치 전송 시점까지 관리합니다.
 */

import type { TrackingEvent } from '../core/sdk';

const MAX_QUEUE_SIZE = 500;

export type QueuedEvent = TrackingEvent;

export class EventQueue {
  private queue: QueuedEvent[] = [];
  private maxSize: number;

  constructor(maxSize: number = MAX_QUEUE_SIZE) {
    this.maxSize = maxSize;
  }

  enqueue(event: QueuedEvent): void {
    if (this.queue.length >= this.maxSize) {
      this.queue.shift();
    }
    this.queue.push(event);
  }

  dequeue(count: number): QueuedEvent[] {
    return this.queue.splice(0, count);
  }

  flush(): QueuedEvent[] {
    const events = [...this.queue];
    this.queue = [];
    return events;
  }

  peek(count: number): QueuedEvent[] {
    return this.queue.slice(0, count);
  }

  size(): number {
    return this.queue.length;
  }

  isEmpty(): boolean {
    return this.queue.length === 0;
  }

  restore(events: QueuedEvent[]): void {
    this.queue.unshift(...events);
    while (this.queue.length > this.maxSize) {
      this.queue.shift();
    }
  }
}
